var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {},
    [
      _c("multiselect", {
        staticClass: "items-center",
        style: { width: _vm.width },
        attrs: {
          options: _vm.options,
          searchable: false,
          "close-on-select": true,
          "show-labels": false,
          placeholder: _vm.placeholderText,
        },
        on: { input: _vm.handleInput },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }